import { render } from "./Documentation.vue?vue&type=template&id=7ab393cc"
import script from "./Documentation.vue?vue&type=script&lang=js"
export * from "./Documentation.vue?vue&type=script&lang=js"

import "./Documentation.vue?vue&type=style&index=0&id=7ab393cc&lang=scss"

import exportComponent from "/home/nboq9356/fdes-meiser.ailoop.io/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__